export default {
  BLACK: '#000000',
  WHITE: '#FFFFFF',
  RED: {
    50: '#FEE6EB',
    100: '#FFA7AF',
    200: '#FF7486',
    300: '#FF415C',
    400: '#FF2C4A',
    500: '#E61E3C',
    600: '#C31834',
    700: '#A1122C',
    800: '#7E0C24',
    900: '#5C061C',
    1000: '#390014'
  },
  ORANGE: {
    50: '#FFDDD3',
    100: '#FDC8B7',
    200: '#FDAC93',
    300: '#FC9170',
    400: '#FB754C',
    500: '#FA5A28',
    600: '#D64D22',
    700: '#B3401D',
    800: '#BF3317',
    900: '#6B2711',
    1000: '#471A0B'
  },
  AMBER: {
    100: '#FFDFB7',
    200: '#FFD093',
    300: '#FFC070',
    400: '#FFB04C',
    500: '#FFA028',
    600: '#DB8922',
    700: '#B6721D',
    800: '#925B17',
    900: '#6D4511',
    1000: '#492E0B'
  },
  YELLOW: {
    100: '#FFF9CC',
    200: '#FFF399',
    300: '#FFED66',
    400: '#FFE733',
    500: '#FFE100',
    600: '#D7BE00',
    700: '#B09B00',
    800: '#887800',
    900: '#615500',
    1000: '#393200'
  },
  GREEN: {
    100: '#C5FACF',
    200: '#8AF59E',
    300: '#50F06E',
    400: '#35D644',
    500: '#1BBC3C',
    600: '#00A223',
    700: '#00851C',
    800: '#006716',
    900: '#004A0F',
    1000: '#002C09'
  },
  TEAL: {
    100: '#DFFCFF',
    200: '#BFF9FF',
    300: '#80F3FF',
    400: '#40ECFF',
    500: '#00E6FF',
    600: '#00C2D7',
    700: '#009EB0',
    800: '#007B88',
    900: '#005761',
    1000: '#003339'
  },
  BLUE: {
    100: '#CCE3FF',
    200: '#99C7FF',
    300: '#66ABFF',
    400: '#2B8EFF',
    500: '#0073FF',
    600: '#0062DD',
    700: '#0051BA',
    800: '#004098',
    900: '#003075',
    1000: '#001F53',
    1100: '#001232'
  },
  PURPLE: {
    50: '#F8E5FB',
    100: '#EDD0FF',
    200: '#E4B9FF',
    300: '#DAA2FF',
    400: '#D18AFF',
    500: '#C873FF',
    600: '#AB63DB',
    700: '#8F52B6',
    800: '#724292',
    900: '#56316D',
    1000: '#392149'
  },
  MAGENTA: {
    50: '#FCDFF4',
    100: '#FBB7E8',
    200: '#F993DD',
    300: '#F770D2',
    400: '#F54CC6',
    500: '#F328BB',
    600: '#D022A0',
    700: '#AE1D86',
    800: '#8B176B',
    900: '#681150',
    1000: '#450B35'
  },
  GREY: {
    50: '#F8F8FA',
    100: '#F0F0F0',
    125: '#EBEBEB',
    150: '#E1E1E1',
    200: '#D7D7D7',
    250: '#CDCDCD',
    300: '#BEBEBE',
    350: '#A5A5A5',
    400: '#8C8C8C',
    450: '#787878',
    500: '#646464',
    550: '#505050',
    600: '#414141',
    650: '#373737',
    700: '#282828',
    750: '#232323',
    800: '#1E1E1E',
    850: '#191919',
    900: '#141414'
  }
};